import { getAccessToken } from "@mgdx-libs/firebase";

import { createFetchTimeout } from "./createFetchTimeout";
import { ServiceTermApi } from "./patient/patient";
import requestHeaders from "./requestHeaders";
import { Configuration } from "./runtime";

export const patientServiceTermApi = new ServiceTermApi(
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_MGDX_API_PATIENT_URL ?? process.env.MGDX_API_PATIENT_URL,
    credentials: "include",
    accessToken: getAccessToken,
    headers: requestHeaders,
    fetchApi: createFetchTimeout(60000, "patientServiceTermApi"),
  })
);
